import gql from "graphql-tag";

export const GetVideos = gql`
  query GetVideos($video: QueryableVideo) {
    videos(video: $video) {
      id
      url
      name
      thumbnailUrl
      wowzaId
      createdAt

      product {
        id
        name
        price
      }
    }
  }
`;

export const GetUnfilteredVideos = gql`
  query GetVideos($id: String) {
    videos(video: { id: $id }) {
      id

      product {
        id
        name
        price
      }
    }
  }
`;

export const GetProducts = gql`
  query GetProducts {
    stores {
      ownedProducts {
        id
      }
    }
    accounts {
      partneredProducts {
        id
        name
      }
    }
  }
`;
